/**
 * Defines the kind of contextual sources for node geometry
 */
export var NodeGeometryContextualSources;
(function (NodeGeometryContextualSources) {
    /** None */
    NodeGeometryContextualSources[NodeGeometryContextualSources["None"] = 0] = "None";
    /** Positions */
    NodeGeometryContextualSources[NodeGeometryContextualSources["Positions"] = 1] = "Positions";
    /** Normals */
    NodeGeometryContextualSources[NodeGeometryContextualSources["Normals"] = 2] = "Normals";
    /** Tangents */
    NodeGeometryContextualSources[NodeGeometryContextualSources["Tangents"] = 3] = "Tangents";
    /** UV */
    NodeGeometryContextualSources[NodeGeometryContextualSources["UV"] = 4] = "UV";
    /** UV2 */
    NodeGeometryContextualSources[NodeGeometryContextualSources["UV2"] = 5] = "UV2";
    /** UV3 */
    NodeGeometryContextualSources[NodeGeometryContextualSources["UV3"] = 6] = "UV3";
    /** UV4 */
    NodeGeometryContextualSources[NodeGeometryContextualSources["UV4"] = 7] = "UV4";
    /** UV5 */
    NodeGeometryContextualSources[NodeGeometryContextualSources["UV5"] = 8] = "UV5";
    /** UV6 */
    NodeGeometryContextualSources[NodeGeometryContextualSources["UV6"] = 9] = "UV6";
    /** Colors */
    NodeGeometryContextualSources[NodeGeometryContextualSources["Colors"] = 10] = "Colors";
    /** VertexID */
    NodeGeometryContextualSources[NodeGeometryContextualSources["VertexID"] = 11] = "VertexID";
    /** FaceID */
    NodeGeometryContextualSources[NodeGeometryContextualSources["FaceID"] = 12] = "FaceID";
    /** GeometryID */
    NodeGeometryContextualSources[NodeGeometryContextualSources["GeometryID"] = 13] = "GeometryID";
    /** CollectionID */
    NodeGeometryContextualSources[NodeGeometryContextualSources["CollectionID"] = 14] = "CollectionID";
    /** LoopID */
    NodeGeometryContextualSources[NodeGeometryContextualSources["LoopID"] = 15] = "LoopID";
    /** InstanceID */
    NodeGeometryContextualSources[NodeGeometryContextualSources["InstanceID"] = 16] = "InstanceID";
})(NodeGeometryContextualSources || (NodeGeometryContextualSources = {}));
//# sourceMappingURL=nodeGeometryContextualSources.js.map